// App.js
import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./components/Home/Home";
import Login from "./components/Login/Login";
import "./App.css";
import Signup from "./components/Signup/Signup";
import VehicleType from "./components/VehicleType/VehicleType";
import BusPage from "./components/VehicleType/publicbus";
import DisplayCollegeBuses from "./components/VehicleType/displaycollegebuses";
import Collegebus from "./components/VehicleType/collegebus";
import { auth } from "./firebase";
import { ThemeProvider } from "./ThemeContext";
import 'mapbox-gl/dist/mapbox-gl.css';
import DisplayVehicles from "./components/VehicleType/Displayvehicles";
import VehicleDetails from "./components/VehicleType/VehicleDetails";
import EditVehicle from "./components/VehicleType/editvehicle";
import Profile from "./components/VehicleType/profile";
import ForgotPassword from "./components/VehicleType/forgotpass";
import ViewLocalBusDetails from "./components/VehicleType/ViewLocalBusDetails";
import Editlocalvehicle from "./components/VehicleType/editlocalvehicle";
import Feedback from "./components/VehicleType/feedback";
function App() {
  const [userName, setUserName] = useState("");

  useEffect(() => {
    auth.onAuthStateChanged((user) => {
      if (user) {
        setUserName(user.displayName);
      } else setUserName("");
    });
  }, []);

  return (
    <ThemeProvider>
      <div className="App">
        <Router>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/VehicleType" element={<VehicleType />} />
            <Route path="/Bus" element={<BusPage />} />
            <Route path="/DisplayCollegeBuses" element={<DisplayCollegeBuses />} />
            <Route path="/Collegebus" element={<Collegebus />} />
            <Route path="/DisplayVehicles" element={<DisplayVehicles />} />
            <Route path="/VehicleDetails/:documentId" element={<VehicleDetails />} />
            <Route path="/editvehicle/:documentId" element={< EditVehicle />} />
            <Route path='/Profile' element={<Profile/>} />
            <Route path="/forgotpass" element={< ForgotPassword />} />
            <Route path="/ViewLocalBusDetails/:documentId" element={< ViewLocalBusDetails />} />
            <Route path="/editlocalvehicle/:documentId" element ={< Editlocalvehicle />} />
            <Route path="/feedback" element ={< Feedback />} />
            
            <Route path="/" element={<Home name={userName} />} />
          </Routes>
        </Router>
      </div>
    </ThemeProvider>
  );
}

export default App;
